import { createContext, useContext, type ReactNode } from "react";
import type { PageCtaPublicItem } from "@shared/pageCtaSlots";

const PageCtaPreviewContext = createContext<PageCtaPublicItem | null>(null);

export function PageCtaPreviewProvider({
  item,
  children,
}: {
  item: PageCtaPublicItem;
  children: ReactNode;
}) {
  return <PageCtaPreviewContext.Provider value={item}>{children}</PageCtaPreviewContext.Provider>;
}

export function usePageCtaPreviewOverride(): PageCtaPublicItem | null {
  return useContext(PageCtaPreviewContext);
}
